import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Denver.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Mobile App Development in Denver?</h2>
            <p>
              You can easily rely on TekRevol's mobile app development expertise
              in Denver, where innovation converges with local excellence,
              delivering tailored solutions for your triumph. We have a proven
              history of delivering top-tier mobile apps that have earned
              industry recognition and success. As a reputable
              Indianapolis-based company, we possess a deep understanding of the
              local market and its unique dynamics, giving your app a
              competitive edge.
            </p>
            <p>
              Our team specializes in crafting bespoke mobile apps that align
              precisely with your distinct business needs and objectives,
              ensuring a perfect solution. Meanwhile, our agile development
              approach guarantees swift iterations, rapid outcomes, and
              adaptability to evolving requirements. We deliver cost-effective
              solutions without compromising quality, ensuring mobile app
              development is accessible to businesses of all scales.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
